<template>
  <div style="width:100vw;height:100vh;background:#EBECED;padding-top:85px;">
    <!--基本信息-->
    <div style="width:1250px;height:calc(100% - 25px);background:#ffffff;margin:0 auto;padding:18px 31px 31px 31px;
    box-shadow:0px 2px 7px #A6A6A6;display:flex;flex-direction:column;">

      <div style="width:68px;height:40px;border-bottom:3px solid #1E3A8A;text-align:center;">
        <p style="font-size:16px;font-weight:bold;">基本信息</p>
      </div>

      <div style="padding-top:46px;flex:1;display:flex;">

        <div style="width:200px;display:flex;flex-direction:column;align-items:center;">
          <img :src="avatar" style="width:120px;height:120px;border-radius:50%;">
          <p style="margin-top:27px;font-size:20px;font-weight:bold;">
            <span v-if="sex==='男'" style="margin-top:2px;margin-right:7px;font-size:22px;color:#35AAE0;" class="iconfontFamily">&#xe6b5;</span>
            <span v-if="sex==='女'" style="margin-top:2px;margin-right:7px;font-size:22px;color:#FF78C3;" class="iconfontFamily">&#xe6b4;</span>
            {{nickName}}
          </p>
        </div>
        <div style="flex:1;margin-left:120px;font-size:20px;">
          <div style="margin-bottom:45px;display:flex;">
            <p style="width:150px;">地区</p>
            <p>{{province}} {{city}}</p>
          </div>
          <div style="margin-bottom:45px;display:flex;">
            <p style="width:150px;">个性签名</p>
            <p>{{signature}}</p>
          </div>
          <div style="margin-bottom:45px;display:flex;">
            <p style="width:150px;">手机号</p>
            <p>{{phone.replace(/(\d{3})\d{4}(\d{3})/,"$1****$2")}}</p>
          </div>

          <p @click="intoNoticeDialog" style="width:165px;color:#2A82E4;cursor:pointer;">查看团队文件通知</p>

        </div>

      </div>

      <div style="color:#a6a6a6;display:flex;align-items:center;">
        <p style="margin-top:2px;margin-right:20px;font-size:20px;" class="iconfontFamily">&#xe6a2;</p>
        <p style="font-size:16px;">如需修改基本信息，请在共生地球App中编辑</p>
      </div>

    </div>



    <v-dialog v-model="noticeDialogShow" persistent width="800" height="650" class="dialog">
      <v-card>
        <v-card-title class="dialogTitle">
          <p class="dialogTitle-title">团队文件通知</p>
          <v-spacer></v-spacer>
          <p @click="closeNoticeDialog" class="dialogTitle-close iconfontFamily">&#xe60d;</p>
        </v-card-title>
        <v-card-text style="height:580px;padding:0;">
          <!--列表有内容-->
          <div v-if="noticeList.length !== 0" ref="noticeListArea" style="width:100%;height:100%;overflow:auto;" class="myScrollArea">
            <div style="width:100%;padding:24px 55px 0 55px;color:#000000;font-size:16px;">
              <div v-for="(item,index) in noticeList" :key="'noticeItem'+index"
                   style="width:calc(100% - 110px);margin:0 auto;border-bottom:1px solid #A6A6A6;padding:18px 0;">
                <div style="height:22px;border-left:3px solid #a6a6a6;padding-left:28px;">{{item.noticeTime}}</div>
                <p style="margin:18px 0 0 30px;">{{item.operation}}</p>
              </div>
              <p v-if="noticeScrollToBottom && noticeListCurrPageNum === noticeListTotalPageNum" style="line-height:66px;text-align:center;font-size:16px;color:#808080;">已全部加载完毕</p>
              <p v-if="noticeScrollToBottom && noticeListCurrPageNum < noticeListTotalPageNum" @click="getNoticeList(noticeListCurrPageNum+1)"
                 style="line-height:66px;text-align:center;font-size:16px;color:#2A82E4;cursor:pointer;">加载更多</p>
            </div>
          </div>

          <!--列表无内容-->
          <div v-if="noticeList.length === 0" style="width:100%;height:100%;">
            <div style="position:relative;top:45%;left:50%;transform:translate(-50%,-50%);width:140px;display:flex;align-items:center;color:#A6A6A6;">
              <p style="margin-right:20px;font-size:32px;" class="iconfontFamily">&#xe691;</p>
              <p style="font-size:20px;">暂无通知</p>
            </div>
          </div>

        </v-card-text>
      </v-card>


    </v-dialog>


  </div>




</template>

<script>
export default {
  name: "UserCenter",
  data(){
    return{
      //基本信息
      avatar:"",
      nickName:"",
      sex:"",

      province:"",
      city:"",
      signature:"",
      phone:"",



      //消息
      noticeDialogShow:false,

      noticeList:[],
      noticeListCurrPageNum:1,
      noticeListTotalPageNum:0,
      noticeScrollToBottom:false,




    }


  },

  methods:{

    //进入首页
    intoLogoPage(){
      this.$router.push({
        path:'/globe'
      })
    },


    getUserInfo(){
      this.$axios({
        method:"get",
        url:"/authorApi/personal-data/getPersonalData",
      }).then((resultData)=>{
        resultData = resultData.data;
        console.log(resultData)
        if(resultData.status === 200){
          this.avatar = resultData.data.picture
          this.nickName = resultData.data.nickName
          this.sex = resultData.data.sex
          this.province = resultData.data.province
          this.city = resultData.data.city
          this.signature= resultData.data.signature
          this.phone = resultData.data.phone
        }
      })
    },

    //进入消息弹窗
    intoNoticeDialog(){
      this.noticeDialogShow = true;
      this.getNoticeList(1);
    },
    closeNoticeDialog(){
      if(this.noticeList.length !== 0){
        this.$refs.noticeListArea.scrollTo({top:0})
        this.$refs.noticeListArea.removeEventListener("scroll",this.noticeListAreaScrollFun)
      }
      this.noticeDialogShow = false;
    },

    //获取消息列表
    getNoticeList(pageNum){
      this.$axios({
        method:"get",
        url:"/authorApi/z-file-notice/getZFileNoticePage",
        params:{
          curPageNum:pageNum,
          maxResultNum:10,
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        console.log(resultData)
        if(resultData.status === 200){

          if(pageNum === 1){
            this.noticeList = resultData.data.list;
          }
          else{
            this.noticeList = this.noticeList.concat(resultData.data.list);
          }
          this.noticeListCurrPageNum = pageNum
          this.noticeListTotalPageNum = resultData.data.totalPageNum;

          if(this.noticeList.length !== 0){
            console.log("监听")
            setTimeout(()=>{
              this.$refs.noticeListArea.addEventListener("scroll",this.noticeListAreaScrollFun)
            },0)
          }
          else{
            this.$refs.noticeListArea.removeEventListener("scroll",this.noticeListAreaScrollFun)
          }

          this.noticeScrollToBottom = false;

        }
      })
    },


    //数据列表滚动到底方法
    noticeListAreaScrollFun(){
      let viewH = this.$refs.noticeListArea.clientHeight;   //视野高度
      let contentH = this.$refs.noticeListArea.scrollHeight;   //内容高度
      let scrollTop =this.$refs.noticeListArea.scrollTop;
      if(scrollTop >= contentH -viewH){
        console.log("滚动到底")
        this.noticeScrollToBottom = true;
      }
    },


  },
  mounted(){
    this.getUserInfo()
  }


}
</script>

<style scoped>

</style>